import { gql } from '@apollo/client';

export const CREATE_USER_FEATURE_FROM_QUESTION = gql`
mutation createUserFeatureFromQuestion( 
    $feature: String!,
    $question: String!,
    $value: Float,
    $importance: Float,
    $valueFreeText: String,
    $valueSingleSelect: String,
    $valueMultiSelect: [String!],
    $reckoning: String) {
  createUserFeatureFromQuestion(
    feature: $feature
    question: $question
    value: $value
    importance: $importance
    valueFreeText: $valueFreeText
    valueSingleSelect: $valueSingleSelect
    valueMultiSelect: $valueMultiSelect
    reckoning: $reckoning
  ) {
    _id
  }
}
`;